import styled from 'styled-components';

const CourseBoxDiv = styled.div`
  margin-bottom: 19px;
  align-items: center;
  display: flex;
`;

export default CourseBoxDiv;
